<template>
  <v-container fluid>
    <div class="modal-padding">
      <v-row>
        <v-col cols="12">
          <div class="center-name">Publish Test Results</div>
        </v-col>
      </v-row>

      <v-row class="mt-3">
        <v-col cols="12" sm="6" offset-sm="3">
          <v-text-field
            v-model.number="rankScale"
            type="number"
            label="Scale All India Rank up to (No. of Students)"
            placeholder="e.g. 8000"
            outlined
            dense
            clearable
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <div class="right-align yes-no-block">
            <v-btn
              @click="onClose({ status: false, confirmationType: 'publish_result', action: 'yes', rank_scale: rankScale, ...data })"
              class="right-btn cust-btn"
              color="primary"
            >
              Yes
            </v-btn>
            <v-btn
              @click="onClose({ status: false, action: 'no', ...data })"
              class="right-btn cust-btn no-btn"
              color="primary"
            >
              No
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'PublishConfirmationDialog',
  props: ['onClose', 'data'],
  data() {
    return {
      rankScale: this.data?.rank_scale || 8000,
    };
  },
};
</script>
